import React from 'react';
import { API_BASE_URL } from '@config/constants';
import { Api } from '@api/Api';
import { nanoid } from 'nanoid';
import axios from 'axios';

export const apiClient = new Api({
  baseURL: API_BASE_URL
});

let tokenGenerator = undefined as (() => Promise<string>) | undefined | null;

export function setTokenGenerator(generator: (() => Promise<string>) | null) {
  tokenGenerator = generator;
}

let networkErrorSetter = undefined as
  | React.Dispatch<React.SetStateAction<boolean>>
  | undefined;

export function setNetworkError(
  dispatch: React.Dispatch<React.SetStateAction<boolean>>
) {
  networkErrorSetter = dispatch;
}

apiClient.instance.interceptors.response.use(undefined, (err) => {
  const { config, response } = err;

  if (axios.isCancel(err)) return;

  if (response) {
    return Promise.reject(err);
  }

  if (!config || !config.retry) {
    if (networkErrorSetter) networkErrorSetter(true);
    return Promise.reject(err);
  }

  config.retry -= 1;
  const delayRetryRequest = new Promise((resolve: any) => {
    setTimeout(() => {
      console.log('retry the request', config.url);
      resolve();
    }, 2000);
  });
  return delayRetryRequest.then(() => apiClient.instance(config));
});

apiClient.instance.interceptors.request.use(async (config) => {
  const token = tokenGenerator ? await tokenGenerator() : undefined;
  if (!token) return config;
  return {
    ...config,
    retry: (config as any).retry ?? 3,
    headers: {
      ...(config.headers ?? {}),
      Authorization: `Bearer ${token}`
    }
  };
});

export const last100CorrelationIds: string[] = [];

apiClient.instance.interceptors.request.use(async (config) => {
  const actionMethods = ['post', 'put', 'patch', 'delete'];
  if (!config.method || !actionMethods.includes(config.method.toLowerCase())) {
    return config;
  }
  const correlationId = nanoid();
  if (last100CorrelationIds.length > 100) {
    last100CorrelationIds.shift();
  }
  last100CorrelationIds.push(correlationId);
  return {
    ...config,
    headers: {
      ...(config.headers ?? {}),
      'x-correlation-id': correlationId
    }
  };
});
